export default {
    nav: {
        //之前没写, 就留空
        subject: ""
    }
}
